module.exports = __webpack_public_path__ + "img/faro2.a6843659.png";